import React from "react";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { Chip } from "@mui/material";
import { AutocompleteRenderValueGetItemProps } from "@mui/material/Autocomplete";
import {
  GridType,
  UhCat,
  DayOfWeekType,
  UhTypeNandcOptionType,
} from "../interfaces";

const getLabel = (value: any): string => {
  if (value.short_name) return value.short_name;
  else return value.label;
};

/**
 * Custom render Tags
 *
 * Displays the tags differently depending on the input
 */
const CustomRenderTags = <
  T extends UhCat | GridType | DayOfWeekType | UhTypeNandcOptionType
>({
  value,
  getTagProps,
  label,
  limitTagsChip,
  isFilter,
  onDelete,
}: {
  value: Array<T>;
  getTagProps: AutocompleteRenderValueGetItemProps<true>;
  label: string;
  limitTagsChip: number;
  isFilter?: boolean;
  onDelete?: (deleteItem: number[]) => void;
}) => {
  const numTags = value.length;

  if (isFilter) {
    return (
      <Chip
        color="secondary"
        deleteIcon={<BackspaceIcon />}
        label={`${value.length} ${label}`}
        onDelete={() => (onDelete ? onDelete(value.map((el) => el.id)) : null)}
      />
    );
  }

  return (
    <>
      {value.slice(0, limitTagsChip).map((tag, index) => {
        const { key, ...rest } = getTagProps({ index });
        return (
          <Chip
            key={key}
            {...rest}
            color="secondary"
            deleteIcon={<BackspaceIcon fontSize={"small"} />}
            label={getLabel(tag)}
            onDelete={() => (onDelete ? onDelete([tag.id]) : null)}
            size="small"
          />
        );
      })}
      <div>{numTags > limitTagsChip && ` +${numTags - limitTagsChip}`}</div>
    </>
  );
};

export default CustomRenderTags;
